import CalendarMonthOutlined from "@mui/icons-material/CalendarMonthOutlined";
import ArrowForwardOutlined from "@mui/icons-material/ArrowForwardOutlined";

/**
 * Shared option set for the two kft interstitials (CommonKftInterstitial,
 * shown after a manual "kft" pick, and CommonKftCegjelzoInterstitial, shown
 * after Cégjelző auto-lookup infers "kft") — same copy, same choice, just
 * reached from two different places in the flow.
 */
export const KFT_INTERSTITIAL_OPTIONS = [
  {
    value: "consultation",
    titleKey: "searchflow.kftinterstitialconsultationtitle",
    descKey: "searchflow.kftinterstitialconsultationdesc",
    Icon: CalendarMonthOutlined,
    // Not marked `recommended` — nudging users toward booking a call over
    // self-service is a product decision, not something to default silently.
    recommended: false,
  },
  {
    value: "continue",
    titleKey: "searchflow.kftinterstitialcontinuetitle",
    descKey: "searchflow.kftinterstitialcontinuedesc",
    Icon: ArrowForwardOutlined,
    recommended: false,
  },
];
